var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "md-headline" },
      [
        _vm._v("Feed Configuration"),
        _c(
          "md-input-container",
          [
            _c("label", { attrs: { for: "sourceType" } }, [
              _vm._v("Source Type")
            ]),
            _c(
              "md-select",
              {
                attrs: {
                  id: "sourceType",
                  name: "sourceType",
                  required: "required"
                },
                model: {
                  value: _vm.entity.ingestType,
                  callback: function($$v) {
                    _vm.$set(_vm.entity, "ingestType", $$v)
                  },
                  expression: "entity.ingestType"
                }
              },
              [_c("md-option", { attrs: { value: "mrss" } }, [_vm._v("MRSS")])],
              1
            )
          ],
          1
        ),
        _c(
          "transition-group",
          {
            attrs: {
              name: "fade",
              "enter-active-class": "animated fadeInDown",
              "leave-active-class": "animated fadeOutUp"
            }
          },
          _vm._l(_vm.entity.urls, function(url, index) {
            return _c(
              "md-layout",
              { key: "fruit-" + index },
              [
                _c(
                  "md-layout",
                  [
                    _c(
                      "md-input-container",
                      {
                        class: {
                          "md-input-invalid":
                            (_vm.formSubmitted &&
                              _vm.validations.urls.$each[index].$invalid) ||
                            _vm.checkUrlError(index)
                        }
                      },
                      [
                        _c("label", [
                          _vm._v(
                            "Source URL " +
                              _vm._s(
                                _vm.entity.urls.length > 1 ? index + 1 : ""
                              )
                          )
                        ]),
                        _c("md-input", {
                          model: {
                            value: _vm.entity.urls[index],
                            callback: function($$v) {
                              _vm.$set(_vm.entity.urls, index, $$v)
                            },
                            expression: "entity.urls[index]"
                          }
                        }),
                        _vm.formSubmitted &&
                        !_vm.validations.urls.$each[index].required
                          ? _c("span", { staticClass: "md-error" }, [
                              _vm._v("This field is required")
                            ])
                          : _vm._e(),
                        _vm.formSubmitted &&
                        !_vm.validations.urls.$each[index].url
                          ? _c("span", { staticClass: "md-error" }, [
                              _vm._v("Invalid URL format")
                            ])
                          : _vm._e(),
                        _vm.checkUrlError(index)
                          ? _c("span", { staticClass: "md-error" }, [
                              _vm._v(
                                "An error has occurred in the last try. Error code: " +
                                  _vm._s(_vm.entity.last_run.status_code)
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm.entity.urls.length > 1
                  ? _c(
                      "md-layout",
                      { attrs: { "md-flex": "5", "md-align": "end" } },
                      [
                        _c(
                          "md-button",
                          {
                            staticClass:
                              "md-icon-button md-warn md-dense remove-url",
                            on: {
                              click: function($event) {
                                return _vm.entity.urls.splice(index, 1)
                              }
                            }
                          },
                          [
                            _c("md-icon", {
                              attrs: { "md-iconset": "fa fa-times" }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          1
        ),
        _c(
          "md-layout",
          { attrs: { "md-align": "end" } },
          [
            _c(
              "md-button",
              {
                staticClass: "md-icon-button md-raised md-dense md-primary",
                on: {
                  click: function($event) {
                    return _vm.entity.urls.push("")
                  }
                }
              },
              [
                _c("md-icon", { attrs: { "md-iconset": "fa fa-plus" } }),
                _c("md-tooltip", { attrs: { "md-direction": "top" } }, [
                  _vm._v("Add URL")
                ])
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-479a057c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-479a057c","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug&optionsId=0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared-components/forms/FeedConfigurationForm.vue
// module id = 980
// module chunks = 0